/* eslint-disable @typescript-eslint/no-explicit-any -- DIRECT-239681 */

export function buildUrl(url: string, params: Record<string, any> = {}) {
    const querystring = String(
        new URLSearchParams(
            Object.entries(params).filter(([_, value]) => value !== null && value !== undefined && !Number.isNaN(value))
        )
    );

    if (!querystring) {
        return url;
    }

    const divider = url.indexOf('?') > -1 ? '&' : '?';

    return url + divider + querystring;
}
